import React from "react"
import clsx from "clsx"
import { isMobileOnly } from "react-device-detect"
import { NavLink } from "react-router-dom"
import { useTranslation } from "react-i18next"

import { useAsideMenu } from "hooks"

export const SubMenuLink: React.FC = () => {
	const { t } = useTranslation()

	const { mainMenuCollection, currentActiveAsideMenu } = useAsideMenu()

	return (
		<div className="c-aside__subMenu-link">
			{mainMenuCollection
				.filter((item) => item.id === currentActiveAsideMenu)
				.map((item) => {
					return (
						<div key={item.id} hidden={!item.isVisible} className={clsx("px-6")}>
							<hr
								className={clsx("c-aside__divider", {
									"c-aside__divider--mobile": isMobileOnly,
								})}
							/>

							<div
								className={clsx("flex items-center my-7 ", {
									"mx-4": !isMobileOnly,
								})}
							>
								<div className="mr-2">{item.icon}</div>
								<div
									className={clsx("font-bold text-lg font-[Jost]", {
										"text-base w-3/5": isMobileOnly,
									})}
								>
									{t(item.label)}
								</div>
							</div>

							<hr
								className={clsx("c-aside__divider", {
									"c-aside__divider--mobile": isMobileOnly,
								})}
							/>

							{item.children.map((subItem, subIndex) => {
								return (
									<div
										className={clsx("flex my-4", { "flex-col": isMobileOnly })}
										key={subIndex}
										hidden={!subItem?.isVisible}
									>
										<NavLink
											to={subItem.url}
											className={({ isActive }) =>
												clsx({
													"is-active": isActive,
													"w-3/4": isMobileOnly,
												})
											}
											target={subItem.external ? "_blank" : ""}
											data-cy={subItem.dataCy}
										>
											<div className="p-3">{t(subItem.label)}</div>
										</NavLink>
									</div>
								)
							})}
						</div>
					)
				})}
		</div>
	)
}
